<template>
  <div class="szw-widget-base-banner">
    <form-banner-skeleton v-if="status === 'loading'" :is-small-widget-container-size="props.isSmallWidgetContainerSize" :events-number="eventsNumber" />

    <template v-else>
      <!-- HOME TEAM FORM -->
      <team-form :team-events="props.homeTeamEvents" :is-small-widget-container-size="props.isSmallWidgetContainerSize" />

      <!-- LABEL & DIVIDERS -->
      <div class="szw-flex szw-flex-row szw-text-xs szw-items-center szw-justify-center szw-gap-2 szw-flex-1 szw-leading-4">
        <div :class="['szw-flex szw-flex-col szw-items-center szw-justify-center', { 'szw-mx-4': !props.isSmallWidgetContainerSize }]">
          <span class="szw-font-semibold szw-text-center">{{ props.scoreboardFormLabel }}</span>
          <span class="szw-text-center szw-mt-2">{{ props.eventsNumberLabel }}</span>
        </div>
      </div>

      <!-- AWAY TEAM FORM -->
      <team-form :team-events="props.awayTeamEvents" :is-small-widget-container-size="props.isSmallWidgetContainerSize" />
    </template>
  </div>
</template>

<script setup>
import FormBannerSkeleton from './skeletons/FormBannerSkeleton.vue'
import TeamForm from './TeamForm.vue'
import { inject } from 'vue'

const props = defineProps({
  homeTeamEvents: {
    type: Array,
    default: () => []
  },
  awayTeamEvents: {
    type: Array,
    default: () => []
  },
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  },
  scoreboardFormLabel: {
    type: String,
    default: ''
  },
  eventsNumberLabel: {
    type: String,
    default: ''
  },
  eventsNumber: {
    type: Number,
    default: 5
  }
})

const status = inject('status')
</script>
